import { Component, Input, Output, EventEmitter } from '@angular/core';
import { vaultActions } from '@src/store/reducers/vaultReducer';
import { Store } from '@src/store';
import { VaultConnectionService } from '@src/services/VaultConnectionService.service';

@Component({
    selector: 'user-vault',
    template: require('./user-vault.component.html')
})
export class UserVaultComponent {
    private _vault: any;
    @Input()
    public set vault(value) {
        this._vault = value;
        if (value && value.ID) {
            this.selectConfig();
        }
    }

    public get vault() {
        return this._vault;
    }

    @Output() public onRemoveVault = new EventEmitter();
    @Output() public onTestVault = new EventEmitter<any>();
    @Output() public onEditLink = new EventEmitter();

    public component: any;

    constructor(private store: Store, private componentService: VaultConnectionService) {
    }

    private selectConfig() {
        this.component = null;
        this.store.dispatch({
            type: vaultActions.GET_VAULT_CREDENTIALS,
            payload: { vaultId: this.vault.ID }
        }).then((res) => {
            this.createPage(res);
        });
    }

    public createPage(htmlTemplate) {
        this.component = this.componentService.createComponent(htmlTemplate);
    }

    public setData = (instance: any) => {
        if (!this.vault.credentials) {
            this.vault.credentials = {};
        }
        instance.isDisabled = true;
        instance.isHidden = true;
        instance.data = { credentials : this.vault.credentials };
        instance.onEditLink = this.onEditLink;
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/authorized/usersRolesManagement/usersManagement/users/user-vault/user-vault.component.ts